<!--
 * @Author: your name
 * @Date: 2020-07-31 11:59:27
 * @LastEditTime: 2020-08-03 17:13:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/pages/form/form.vue
-->
<template>
  <div class="form">
    <keep-alive :include="include">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  provide() {
    return {
      addKeepAlive: this.addKeepAlive,
      removeKeepAlive: this.removeKeepAlive
    }
  },
  data() {
    return {
      keepAliveComps: {}
    }
  },
  computed: {
    include() {
      return Object.keys(this.keepAliveComps)
    }
  },
  methods: {
    addKeepAlive(compName) {
      this.$set(this.keepAliveComps, compName, true)
    },
    removeKeepAlive(compName) {
      this.$delete(this.keepAliveComps, compName)
    }
  }
}
</script>

<style lang="scss">
.form {
  height: 100%;
}
</style>
